/* lua.js generated code undefined */

require("clover/panel/component/common/UIGroupButton")

let ManualLocationPanel = xClass("ManualLocationPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/location.pack",
)
ManualLocationPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
let _instance = null
ManualLocationPanel.getInstance = function () {
    let self = this
    return _instance
}
ManualLocationPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self

    this.data = data || {}
    this.cb = data.cb
    this.lMgr = LocationManager.getInstance()
    self.initUI();
}
ManualLocationPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
ManualLocationPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}

ManualLocationPanel.prototype.initUI = function () {
    LocationManager.dcPageShow()
    let self = this

    self.mainNode = cc.CSLoader.createNode("cocos/location_manual_location.csb")
    self.addChild(self.mainNode);

    this.btnClose = self.mainNode.getChildByName("notice_btn_close");
    // this.btnClose.setVisible(false)
    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        if (this.isbusy) return
        this.isbusy = true
        this.onClose();
        this.isbusy = false
    }, true);

    this.img_help = self.mainNode.getChildByName("img_help");
    // this.btnClose.setVisible(false)
    quickBuildBtn(this.img_help, UIGroupButton, PushBounceAnim, () => {
        if (this.isbusy) return
        this.isbusy = true
        // this.onClose();
        LocationManager.dcNoteClick()
        this.lMgr.showExplainPanel(()=>{
            this.isbusy = false
        })
    }, true);

    this.chooseBtn = self.mainNode.getChildByName("button");
    // this.btnClose.setVisible(false)
    quickBuildBtn(this.chooseBtn, UIGroupButton, PushBounceAnim, () => {
        if(this.lMgr.getState() == LocationManager.STATE.CAN_SELECT){
            this.onSelectClick()
        }else{
            if (this.isbusy) return
            this.isbusy = true
            this.onClose();
            this.isbusy = false
        }

        // "%e5%8c%97%e4%ba%ac": 1644808472735,
        // "%e4%b8%8a%e6%b5%b7": 1647227572735
        // UserManager.getInstance().location.province = "测试"
        // if (  this.cb){
        //     this.cb()
        // }
    }, true);

    this.mainNode.getChildByName("tittle").width = 270
    this.mainNode.getChildByName("tittle").x = -50

    this.location_lab = self.mainNode.getChildByName("location_lab");
    this.location_lab.getVirtualRenderer().setAlignment(cc.TEXT_ALIGNMENT_LEFT)
    this.node_tip = self.mainNode.getChildByName("node_tip");
    this.tip_txt = self.mainNode.getChildByName("tip_txt");
    this.tip_txt.width = 450
    
    this.node_tip_label = cc.LabelTTF.create("当前定位准确", null, 19);
    this.node_tip_label.setColor(cc.c4b(193, 125, 71, 255))
    // locationName.setAlignment(cc.TEXT_ALIGNMENT_LEFT)
    // locationName.setAnchorPoint(0,0.5)
    this.node_tip.addChild(this.node_tip_label)

    this.initItemClass()
    this.initListUI()
    this.refreshUI()

    
    
}
ManualLocationPanel.prototype.onSelectClick = function(){
    if (this.isbusy) return
    this.isbusy = true

    // 如果选择和当前定位一致 提示无法重复定位
    let selectName = this.loactionList[this.selecteIndex]
    let location = UserManager.getInstance().location

    if (selectName == location.province){
        Toast.make(getText("当前定位一致"));
        this.isbusy = false
        return
    }
    if (!selectName){
        this.isbusy = false
        return
    }
    LocationManager.dcLocationClick(this.loactionList.length,location.province,selectName)
    let locationConfig = MetaManager.getManualLocationConfig()

    let contentStr = getText("positionSwitch.confirm.text").replace("{day}", locationConfig.location_set_cd_days)
    Dialog.show({type : 2, content : contentStr, title : "提示",buttonNum:1, confirmCallBack:()=>{
        let chosseName = encodeURI(selectName).toLowerCase()
        cc.log("[location]", "ManualLocationPanel initUI chosseName",chosseName); 
        // this.isbusy = false
        this.lMgr.chosseLocation(chosseName,()=>{
            if (this.cb){
                this.cb()
            }
            this.isbusy = false
            this.onClose()
        },()=>{
            this.isbusy = false
        })
    },closeCallBack:()=>{
        this.isbusy = false
    }})
}

ManualLocationPanel.prototype.initItemClass = function()
{
    let self = this
    this.itemTemplete = self.mainNode.getChildByName("location_item")
    self.mainNode.getChildByName("location_item").setVisible(false)
    // this.itemTemplete.getChildByName("location_sh").setString("上海")

}

ManualLocationPanel.prototype.initListUI = function () {
    let self = this
    // 初始化列表
    let container = self.mainNode.getChildByName("container");
    this.container = container
    let scrollView = ccui.ScrollView.create()
    scrollView.setAnchorPoint(0.5,0.5)
    scrollView.setDirection(ccui.ScrollViewDir.vertical)
    scrollView.setContentSize(container.width, container.height)
    scrollView.setClippingEnabled(true)
    scrollView.setBounceEnabled(true)
    scrollView.setScrollBarEnabled(false)

    
    self.scrollView = scrollView
    self.mainNode.addChild(scrollView)
    scrollView.x = container.x;
    scrollView.y = container.y;

    self.selecteIndex = 0

    this.refreshListUI()
}
ManualLocationPanel.prototype.refreshUI = function () {
    let locationName = LocationManager.getInstance().getProvinceName()
    this.location_lab.setString(locationName)
    if(this.lMgr.getState() == LocationManager.STATE.MANUAL){
        // 手动定位 且未到冷却时间
        this.node_tip.setVisible(true)
        this.scrollView.setVisible(false)
        this.tip_txt.setVisible(false)
        this.node_tip_label.setString("已经切换过定位，暂时无法切换哦~")

    }else if(this.lMgr.getState() == LocationManager.STATE.CAN_SELECT){
        // 定位可选
        this.node_tip.setVisible(false)
        this.scrollView.setVisible(true)
    }else{
        // 定位准确
        this.node_tip.setVisible(true)
        this.scrollView.setVisible(false)
        this.tip_txt.setVisible(false)
        this.node_tip_label.setString("当前定位准确")

    }

}

ManualLocationPanel.prototype.refreshListUI = function () {
    let self = this
    let size =  this.container.getContentSize()
    let itemSize = this.itemTemplete.getContentSize()

    // initListUI
    let location = UserManager.getInstance().location

    let loactionList = location.locationList
    this.loactionList = loactionList
    // for (let i = 0; i < 6; i++) {
    //     loactionList[i] = 0
        
    // }
    let realHeight = size.height > loactionList.length*itemSize.height ? size.height : loactionList.length*itemSize.height
    self.scrollView.setInnerContainerSize(cc.size(size.width,realHeight))

    let createItem = (index)=>{
        let node = cloneUINode(this.itemTemplete)
        node.setVisible(true)
        let img_checkbox = node.getChildByName("img_checkbox")
        let img_check = img_checkbox.getChildByName("img_check")
        quickBuildBtn(img_checkbox, UIGroupButton, PushBounceAnim, () => {
            img_check.setVisible(!img_check.isVisible())
            self.selecteIndex = index
            self.refreshListUI()
        }, true);

        let locationName = cc.LabelTTF.create("上海", null, 25);
        locationName.setColor(cc.c4b(224, 58, 40, 255))
        locationName.setAlignment(cc.TEXT_ALIGNMENT_LEFT)
        locationName.setAnchorPoint(0,0.5)
        
        locationName.setPosition(-itemSize.width/2 + 30,-5)
        node.addChild(locationName)
        locationName.setName("locationName")
        self.scrollView.addChild(node)
        return node
    }

    let refreshItem = (node,index)=>{
        // node.y = realHeight - itemSize.height*(index+0)
        node.setPosition(itemSize.width/2,realHeight - (index+1/2)*itemSize.height )
        let conf =loactionList[index]

        let img_plane = node.getChildByName("img_plane")
        img_plane.setVisible(index%2 == 0)

        let img_checkbox = node.getChildByName("img_checkbox")
        let img_check = img_checkbox.getChildByName("img_check")
        img_check.setVisible(self.selecteIndex == index)
        let str = conf
        if (str == 0){
            str = "其它"
        }
        // let str = HeDisplayUtil.urlDecode(conf[i])
        node.getChildByName("locationName").setString(str)
        
        

    }

    for (let i = 0; i < loactionList.length; i++) {
        let node = this.scrollView.getChildren()[i]
        if (!node){
            node = createItem(i)
        }
        refreshItem(node,i)
    }
}

module.exports = ManualLocationPanel